import { render, staticRenderFns } from "./ViewWebsiteGroup.vue?vue&type=template&id=36b89883&"
import script from "./ViewWebsiteGroup.vue?vue&type=script&lang=ts&"
export * from "./ViewWebsiteGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ViewWebsiteGroup.vue?vue&type=style&index=0&id=36b89883&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports